import Button from './Button'
import classes from './SimpleCopyTextButton.module.css'

export default function SimpleCopyTextButton({textToCopy}) {

    function copyTextHandler() {
        let htmlToCopy = textToCopy

        navigator.clipboard.writeText(htmlToCopy)
    }

    return <>
        {textToCopy && <div className={classes.wrapper}>
            <Button title='copy person #' click={copyTextHandler} btnStyle={'btn_simple'}><i className="ti ti-copy"></i></Button> {textToCopy}
        </div>}
    </>
}